import React from 'react';

const DashboardStats = ({ stats, type = 'default' }) => {
    if (!stats) return null;

    return (
        <div className="bg-white p-6 rounded-lg shadow-md mb-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">
                {stats.title || 'Summary'} ({stats.month || 'Current Month'})
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 text-center divide-y md:divide-y-0 md:divide-x divide-gray-200">

                {/* Metric 1 */}
                <div className="p-2">
                    <p className="text-sm text-gray-500">{stats.metric1Label || 'Total Revenue'}</p>
                    <p className="text-2xl font-bold text-gray-900">
                        {stats.metric1Value !== undefined ? stats.metric1Value : '-'}
                    </p>
                    {stats.metric1Subtext && <p className="text-xs text-gray-400 mt-1">{stats.metric1Subtext}</p>}
                </div>

                {/* Metric 2 */}
                <div className="p-2">
                    <p className="text-sm text-gray-500">{stats.metric2Label || 'Total Policies'}</p>
                    <p className="text-2xl font-bold text-blue-600">
                        {stats.metric2Value !== undefined ? stats.metric2Value : '-'}
                    </p>
                </div>

                {/* Metric 3 */}
                <div className="p-2">
                    <p className="text-sm text-gray-500">{stats.metric3Label || 'Total Commission'}</p>
                    <p className="text-2xl font-bold text-green-600">
                        {stats.metric3Value !== undefined ? stats.metric3Value : '-'}
                    </p>
                </div>

                {/* Metric 4 */}
                <div className="p-2">
                    <p className="text-sm text-gray-500">{stats.metric4Label || 'Status'}</p>
                    <p className={`text-2xl font-bold ${stats.metric4Color || 'text-gray-800'}`}>
                        {stats.metric4Value !== undefined ? stats.metric4Value : '-'}
                    </p>
                </div>

            </div>
        </div>
    );
};

export default DashboardStats;
